<template>
    <section :class="show ? 'show' : 'hide'">
      <ul class="list ul-h">
        <li @click="funcClicked(index)" v-for="(item, index) in list" :key="index">
            {{item}}
            <div :class="['sepline', index == list.length-1 ? 'sepline-hide' : 'sepline-show']"></div>
        </li>
      </ul>
    </section>
  </template>
  <script>
  export default {
    data () {
        return {
            
        }
    },
    props: {
      list: {
        type: Array,
        default () {
          return ['操作说明','用户协议','待充值订单']
        }
      },
      funcClicked: {
        type: Function,
        default () {
            return this.listClicked()
        }
      },
      show: {
        type: Boolean,
        default() {
            return false
        }
      }
    },
    methods: {
        listClicked () {
        }
    }
  }
  </script>
  <style lang="scss" scoped>
  @import "@/assets/css/color.scss";
  .list {
    position: absolute;
    right: 4%;
    top: 80px;
    width: 263px;
    background: rgba(0,0,0,0.5);
    border-radius: 8px;
    z-index: 1;
    li {
        height: 77px;
        line-height: 76px;
        font-size: 30px;
        text-align: center;
        color: #fff;
        .sepline {
            width: 100%;
            height: 1px;
            background-color: #fff;
        }
        .sepline-hide {
            display: none;
        }
        .sepline-show {
            display: block;
        }
    }
  }
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  </style>
  